import FieldEquationForm from 'scoreboard/datasets/field-equation-form'
import _ from 'lodash'

var FieldFormEquationForm = FieldEquationForm.extend({

	/**
	 * The dialog that allows for editing a dataset field's equation.
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Object} options.field the field being edited
	 *
	 * @param {Object} context the context from the window that launched this view
	 */
	initialize: function(options = {}, context = {}) {
		options.data = options.field
		options.useNativeColumns = true
		this.ctx = context
		const datasetBeingEdited = options.model
		FieldEquationForm.prototype.initialize.call(this, options)
		// set the initialModel here, because in FieldEquationForm the options are deep copied,
		// but when editing filters on field's equations, we need to edit datasetBeingEdited.filters
		this.initialModel = datasetBeingEdited
		// FieldEquationForm uses the key data.aggregations, but DatasetField.java#datasetAggregations
		// is what we actually want
		this.aggregations = _.cloneDeep(_.get(options, 'data.datasetAggregations', []))
	},

	context: function() {
		return this.ctx
	},

	allowAnyDataset: _.constant(false),

	isHideAggregationType: function() {
		// if we're editing the base dataset, and not a linked dataset we hide
		if (this.isSameDataset()) return true

		return FieldEquationForm.prototype.isHideAggregationType.apply(this, arguments)
	},

	submit: function() {
		this.saveState()
		this.onDone()
		const shouldSubmit = this.submitGuard()
		if (!shouldSubmit) {
			return
		}

		const equation = this.equationEditor.getCleanEquation()
		const data = _.extend({}, this.options.data, {
			equation,
			datasetAggregations: this.aggregations
		})
		this.trigger('done', data)
	}

})

export default FieldFormEquationForm

FieldFormEquationForm.__filename__ = 'datasets/edit/fields/field-form-equation-form.js'
